import { FC, useState, useEffect } from "react";
import { useSegmentStore } from "../../hooks/useSegmentStore";
import { Breadcrumbs, Grid } from '@mui/material';
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { Segment } from "../../types/slices/segmentType";
import { SegmentModal } from "./components/SegmentModal";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { CustomBreadcrumb } from "../../components/common/CustomBreadcrumb/CustomBreadcrumb";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'description', label: 'Descripción', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const Segments:FC = () => {
    const navigate = useNavigate()
    const { segments, getSegments, deleteSegment, setEditSegment, setActionSegment } = useSegmentStore()
    
    const [loading, setLoading] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false)
    const [rowSelected, setRowSelected] = useState<any>('')
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [searchTimeout, setSearchTimeout] = useState<any>(null)
    const [search, setSearch] = useState<string>('')

    useEffect(() => {
        getSegmentsApi()
    }, [])
    
    useEffect(()=>{
        getSegmentsApi()
    }, [search])

    const getSegmentsApi = async () => {
        setLoading(true)
        let payload:any = {}
        if (search !== '') {
            payload = {
                search
            }
        }
        await getSegments(payload)
        setLoading(false)
    }

    const onAdd = () => {
        setEditSegment({} as Segment)
        setActionSegment('')
        setShowModal(true)
    }

    const onEdit = (rowSelected:any) => {
        setActionSegment('')
        setRowSelected(rowSelected)
        setEditSegment(rowSelected)
        setShowModal(true)
    }

    const onDelete = (rowSelected:any) => {
        setActionSegment('')
        setRowSelected(rowSelected)
        setShowModalConfirm(true)
    }

    const onDeleteConfirm = async () => {
        setLoading(true)
        setShowModalConfirm(false)
        await deleteSegment(rowSelected.id)
        await getSegmentsApi()
        setLoading(false)
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => {setSearch(term)}, 1000)
        )
    }

    const onDetails = (rowSelected:any) => {
        setActionSegment('detail')
        setEditSegment(rowSelected)
        setShowModal(true)
    }

    return (<>
        <Breadcrumbs aria-label="breadcrumb" sx={{mt:3}}>
            <CustomBreadcrumb label={"Maestros"} />
            <CustomBreadcrumb label={"Segmentos"}
                onClick={() => {
                    navigate({ pathname: RoutesMap.SEGMENTS })
                }}
            />
        </Breadcrumbs>
        <Grid item xs={12}>
            <CustomTable 
                title={'Segmentos'}
                columns={columns} 
                loading={loading}
                rows={segments || []}
                onRowClick={() => {}}
                hasOptions
                onAddFn={onAdd}
                onAddFnName={'Nuevo segmento'}
                onDetails={onDetails}
                onDelete={onDelete}
                onEdit={onEdit}
                onSearch={onSearch}
                dense
            />
        </Grid>
        {
            showModal && (
                <SegmentModal
                    open = {showModal}
                    closeModal = {() => {setShowModal(false)}}
                    categorySelected = {rowSelected}
                    onList = {() => getSegmentsApi()}
                    // clearState = {clearState}
                />
            )
        }
        {
            showModalConfirm && (
                <ModalConfirm
                    open={showModalConfirm}
                    closeModal={()=>{ setShowModalConfirm(false)}}
                    onConfirm={onDeleteConfirm}
                    status={loading}
                    // clearState = {clearState}
                />
            )
        }
    </>)
}